import React, { createContext, useState, useEffect, useRef } from 'react';
// import { Navigate } from 'react-router-dom';

// Создаем контекст
export const AuthContext = createContext();

// Провайдер контекста
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserProfile, setCurrentUserProfile] = useState(null);
  const [role, setRole] = useState(null);
  const [tgsecretkey, setTgsecretkey] = useState(null);
  const [loading, setLoading] = useState(true);
  const isLoggingOut = useRef(false);

 

  // Функция для получения текущего пользователя
  const fetchCurrentUser = async () => {
    if (isLoggingOut.current) return;
    try {
           // 1) Берём токен из localStorage
     const token = localStorage.getItem('user_token');
     let headers = {};
     if (token) {
       headers['Authorization'] = `Bearer ${token}`;
     }
      const response = await fetch('/api/auth/current_user', {
        credentials: 'include',  // Включаем куки для сессии
        headers
      });
  
      const data = await response.json();
      setLoading(false);

      if (!data.authorized) {
        setCurrentUser(null);
        setCurrentUserProfile(null);
        setTgsecretkey(null);
        setRole(null);
        console.log('User is not authorized');
        return null;
      } else {
        const user = data.user;

        // Очищаем пустые строки
        const cleanUser = Object.fromEntries(
          Object.entries(user).map(([key, val]) => [key, typeof val === 'string' && val.trim() === '' ? null : val])
        );

        setCurrentUser(cleanUser);
        setCurrentUserProfile(cleanUser);
        setTgsecretkey(cleanUser.tgsecretkey || null);
        setRole(cleanUser.role || null);
        console.log('User loaded:', cleanUser);
        return cleanUser;
      }
      
    } catch (error) {
      console.error('Error fetching user:', error);
      setLoading(false);
      return null;
    }
  };

  
   

  // Выполняем получение текущего пользователя при монтировании компонента
  useEffect(() => {
    fetchCurrentUser();
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, fetchCurrentUser, setCurrentUser, currentUserProfile, setCurrentUserProfile, role,setRole ,loading, tgsecretkey, setTgsecretkey,isLoggingOut: isLoggingOut }}>
      {children}
    </AuthContext.Provider>
  );
};
